import React from 'react';

/**
 * 菜单项配置类型
 */
export interface MenuRoute {
  /** 菜单唯一标识 */
  key: string;
  /** 路由路径 */
  path?: string;
  /** 菜单显示名称 */
  label: string;
  /** 菜单图标 */
  icon?: React.ReactNode;
  /** 子菜单 */
  children?: MenuRoute[];
  /** 允许访问的角色列表 */
  roles?: string[];
  /** 是否在菜单中隐藏 */
  hideInMenu?: boolean;
  /** 外部链接 */
  externalLink?: string;
}

/**
 * 默认菜单配置
 *
 * 管理端侧边栏菜单结构，按功能模块分组。
 * 各角色可见的菜单项由 roles 字段控制。
 */
export const defaultMenus: MenuRoute[] = [
  {
    key: 'dashboard',
    path: '/dashboard',
    label: '工作台',
    icon: <span>📊</span>,
  },
  {
    key: 'event-edition-mgmt',
    label: '届次管理',
    icon: <span>🏆</span>,
    roles: ['SUPER_ADMIN'],
    children: [
      {
        key: 'event-edition-list',
        path: '/event-editions',
        label: '届次列表',
        roles: ['SUPER_ADMIN'],
      },
    ],
  },
  {
    key: 'event-mgmt',
    label: '活动管理',
    icon: <span>📅</span>,
    children: [
      {
        key: 'event-list',
        path: '/events',
        label: '活动列表',
      },
      {
        key: 'venue-list',
        path: '/venues',
        label: '场地管理',
      },
      {
        key: 'agenda-management',
        path: '/agenda',
        label: '议程管理',
        roles: ['SUPER_ADMIN', 'EVENT_ADMIN'],
      },
    ],
  },
  {
    key: 'guest-mgmt',
    label: '嘉宾管理',
    icon: <span>👥</span>,
    children: [
      {
        key: 'guest-list',
        path: '/guests',
        label: '嘉宾列表',
      },
      {
        key: 'guest-import',
        path: '/guests/import',
        label: '批量导入',
        roles: ['SUPER_ADMIN', 'EVENT_ADMIN'],
      },
    ],
  },
  {
    key: 'checkin-mgmt',
    label: '签到管理',
    icon: <span>✅</span>,
    children: [
      {
        key: 'checkin-management',
        path: '/checkin',
        label: '签到操作',
        roles: ['SUPER_ADMIN', 'EVENT_ADMIN'],
      },
      {
        key: 'checkin-records',
        path: '/checkin/records',
        label: '签到记录',
      },
      {
        key: 'checkin-statistics',
        path: '/checkin/statistics',
        label: '签到统计',
      },
    ],
  },
  {
    key: 'notification-mgmt',
    label: '消息通知',
    icon: <span>📨</span>,
    children: [
      {
        key: 'notification-templates',
        path: '/notifications/templates',
        label: '通知模板',
      },
      {
        key: 'notification-send',
        path: '/notifications/send',
        label: '发送通知',
        roles: ['SUPER_ADMIN', 'EVENT_ADMIN'],
      },
      {
        key: 'notification-records',
        path: '/notifications/records',
        label: '通知记录',
      },
    ],
  },
  {
    key: 'system',
    label: '系统管理',
    icon: <span>⚙️</span>,
    children: [
      {
        key: 'user-list',
        path: '/users',
        label: '用户管理',
        roles: ['SUPER_ADMIN'],
      },
    ],
  },
];
